import { Fragment, Suspense, lazy } from 'react';
import { Route, Navigate, Routes as Switch } from 'react-router-dom';
import LoadingScreen from 'components/LoadingScreen';
import { MainLayout } from 'layouts/MainLayout';
import AuthGuard from 'components/AuthGuard';
import ExternalVideoPage from 'pages/ExternalVideo';
import { StudioLayout } from './StudioLayout';
import { ExternalLayout } from './ExternalLayout';

export const renderRoutes = (routes: any = []): JSX.Element => (
  <Switch>
    {routes.map((route: any, index: any) => {
      const Guard = route.guard || Fragment;
      const Layout = route.layout || Fragment;
      const Component = route.component;

      return (
        <Route
          key={index}
          {...route}
          element={
            <Guard>
              <Layout>
                {route.routes ? (
                  renderRoutes(route.routes)
                ) : (
                  <Suspense fallback={<LoadingScreen />}>
                    <Component />
                  </Suspense>
                )}
              </Layout>
            </Guard>
          }
        />
      );
    })}
  </Switch>
);

export const routes: any = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('pages/NotFound'))
  },
  {
    exact: true,
    path: '/login',
    component: lazy(() => import('pages/Login'))
  },
  {
    exact: true,
    path: '/client',
    component: lazy(() => import('pages/Redirect'))
  },
  {
    path: 'workspace/:workspaceId/studio/:videoId/*',
    layout: StudioLayout,
    guard: AuthGuard,
    routes: [
      {
        path: '/',
        exact: true,
        component: () => <Navigate to="/external-share" />
      },
      {
        exact: true,
        path: '/video-details',
        component: lazy(() => import('pages/ExternalShare'))
      },
      {
        exact: true,
        path: '/edit-mix',
        component: lazy(() => import('pages/EditAndMix'))
      },
      {
        exact: true,
        path: '/bg-mix',
        component: lazy(() => import('pages/BackgroundMix'))
      },
      {
        exact: true,
        path: '/polls',
        component: lazy(() => import('pages/Polls'))
      },
      {
        exact: true,
        path: '/speaker-info',
        component: lazy(() => import('pages/SpeakerInfo'))
      },
      {
        exact: true,
        path: '/resources',
        component: lazy(() => import('pages/Resources'))
      }
    ]
  },
  {
    path: 'video/:videoId/external',
    layout: ExternalLayout,
    component: () => <ExternalVideoPage />
  },
  {
    path: '*',
    layout: MainLayout,
    guard: AuthGuard,
    routes: [
      {
        path: '/',
        exact: true,
        component: lazy(() => import('pages/Workspace'))
      }
    ]
  },
  {
    path: 'workspace/:workspaceId/*',
    layout: MainLayout,
    guard: AuthGuard,
    routes: [
      {
        path: '/',
        exact: true,
        component: lazy(() => import('pages/Workspace'))
      },
      {
        exact: true,
        path: '/search',
        component: lazy(() => import('pages/Search'))
      },
      {
        exact: true,
        path: '/videos/all',
        component: lazy(() => import('pages/UserChannelV2'))
      },
      {
        exact: true,
        path: '/videos/all/:videoId',
        component: lazy(() => import('pages/UserChannelV2'))
      },
      {
        path: '/user/channel/:channelId',
        exact: true,
        component: lazy(() => import('pages/UserChannelV2'))
      },
      {
        path: '/user/channel/:channelId/video/:videoId',
        exact: true,
        component: lazy(() => import('pages/VideoV2'))
      },
      // {
      //   path: '/user/channel/:channelId/video/:videoId',
      //   exact: true,
      //   component: lazy(() => import('pages/Video'))
      // },
      {
        path: '/channel/:channelId/playlist/:playlistId',
        exact: true,
        component: lazy(() => import('pages/Playlist'))
      }
    ]
  }
];
